export const CSS_CLASSES = {
	BUTTON: 'accordion__button',
	CONTAINER: 'root__container',
};
